import React from 'react';
import {useParams} from 'react-router-dom';


import { SyncOutlined, WarningOutlined } from '@ant-design/icons';

import {useParameterizedQuery} from 'react-fetching-library';
import {resolveAction} from '../../Actions/MailActions/MailActionsActions';
import {useAuthDispatch} from '../../Context/AuthProvider/AuthProvider';
import {logout} from '../../Context/AuthProvider/AuthProviderActions';
import {Bullseye} from '../../Components/Bullseye';
import { EmptyState } from 'src/Components/EmptyState';
import { Button } from 'antd';
export const AprobarJWTAction : React.FunctionComponent = (_props) => {
    const params = useParams();
    const [hasError, setHasError] = React.useState<boolean>(false);
    const [refresh, setRefresh] = React.useState<boolean>(true);

    const [message, setMessage] = React.useState<string>('');
    const [title, setTitle] = React.useState<string>('');


    const resolve = useParameterizedQuery( resolveAction );
    const dispatch = useAuthDispatch();

    const icon = React.useMemo( () => {
        if ( hasError ){
            return <WarningOutlined />;
        }
        return  <SyncOutlined />;
    }, [hasError] );

    const logoutFunc = React.useCallback( () => {
        logout( dispatch ).then();
    }, [dispatch] );

    React.useEffect( () => {
        if( params.tokenJWT === undefined || params.tokenJWT === '' ) {
            setHasError(true);
            setTitle('URL dañada');
            setMessage('La URL que usted intenta acceder esta dañada, intente de nuevo mas tarde.');
        }else{
            if( refresh ){
                setRefresh(false);

                setHasError(false);
                setTitle('Validando información');
                setMessage('Estamos conectando con el servidor, esta accion puede demorar unos segundos.');

                resolve.query( params.tokenJWT ).then( (response) => {
                    if (response.payload){
                        if( response.payload.error['has-error'] ){
                            setHasError(true);
                            setTitle('Error al validar');

                            if (response.payload.error.error){
                                setMessage(response.payload.error.error);
                            }
                        }else{
                            setHasError(false);
                            setTitle('Validación exitosa');
                            setMessage('La información ha sido validada correctamente, puede cerrar esta ventana.');
                        }
                    }


                } );
            }

        }
    }, [params, refresh, resolve] );

    return (
        <Bullseye>
            <EmptyState icon={ icon }
                        title={title}
                        EmptyStateBody={ message }
                        EmptyStateSecondaryActions={ <Button type="primary" onClick={ logoutFunc }>Cerrar Sesión</Button> }
            />
        </Bullseye>
    );
};
